import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

const VisaBannerContent = styled.div`
  ${Summary} {
    margin-bottom: 8px;
  }

  ${SmallPrint} {
    margin-top: 16px;
  }
`;

export default VisaBannerContent;
